/*
 * @Author: your name
 * @Date: 2020-12-11 13:43:13
 * @LastEditTime: 2022-10-27 14:48:42
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/router/tab-admin/index.js
 */

export const tabAdminRouterList = [
  /**
   * Tab details home page
   * @param venueId {String} venueId
   * @param tabId {String} tabId
   */
  /**
   * tab 的详情主页
   * @param venueId {String} venue 的 id
   * @param tabId {String} tab 的 id
   */
  {
    path: '/v/:venueId/tab-admin/:tabId/menu',
    props: true,
    name: 'tab-menu',
    component: () => import('views/tab-admin/tab-menu'),
    meta: {
      barShow: true,
      barTitle: 'Manage my tab',
      showArrow: false,
    },
  },

  /**
   * Order history page under tab
   * @param venueId {String} venueId
   * @param tabId {String} tabId
   */
  /**
   * tab 下的历史订单页
   * @param venueId {String} venue 的 id
   * @param tabId {String} tab 的 id
   */
  {
    path: '/v/:venueId/tab-admin/:tabId/history',
    props: true,
    name: 'tab-history',
    component: () => import('views/tab-admin/tab-history'),
    meta: {
      barShow: true,
      barTitle: 'Order history',
      showArrow: true,
    },
  },

  /**
   * Change tab details page
   * @param venueId {String} venueId
   * @param tabId {String} tabId
   */
  /**
   * 更改 tab 详情信息页
   * @param venueId {String} venue 的 id
   * @param tabId {String} tab 的 id
   */
  {
    path: '/v/:venueId/tab-admin/:tabId/update',
    props: true,
    name: 'tab-update',
    component: () => import('views/tab-admin/tab-update'),
    meta: {
      barShow: true,
      barTitle: 'Update your details',
      showArrow: true,
    },
  },

  /**
   * Tab Related Pages
   * @param venueId {String} venueId
   * @param tabId {String} tabId
   */
  /**
   * tab 相关页面
   * @param venueId {String} venue 的 id
   * @param tabId {String} tab 的 id
   */
  {
    path: '/v/:venueId/tab-admin/:tabId/order',
    props: true,
    name: 'tab-order',
    component: () => import('views/tab-admin/tab-order')
  },
  {
    path: '/v/:venueId/tab-admin/:tabId',
    props: true,
    name: 'tab-input-info',
    component: () => import('views/tab-admin/tab-input-info'),
    children: [
      /**
       * Tab's payment details
       */
      /**
       * tab 的付款详细信息
       */
      {
        path: 'payment',
        props: true,
        name: 'tab-payment',
        component: () => import('views/tab-admin/tab-input-info/tab-payment'),
        meta: {
          barShow: true,
          barTitle: 'Set up your tab',
          showArrow: true,
        },
      },
      /**
       * Mobile tail number verification of tab
       */
      /**
       * tab 的手机尾号校验
       */
      {
        path: 'code',
        props: true,
        name: 'tab-code',
        component: () => import('views/tab-admin/tab-input-info/tab-code'),
        meta: {
          barShow: true,
          barTitle: 'Set up your tab',
          showArrow: false,
        },
      },
      /**
       * Details page of tab
       */
      /**
       * tab 的详情信息页
       */
      {
        path: 'info',
        props: true,
        name: 'tab-info',
        component: () => import('views/tab-admin/tab-input-info/tab-info'),
        meta: {
          barShow: true,
          barTitle: 'Set up your tab',
          showArrow: false,
        },
      },
    ]
  },
]